import React, { useState } from 'react';
import ERDashboardMain from './ERDashboardMain';
import ERByThreeVsPy from './ERByThreeVsPy';
import './ERDashboard.css';

function ERDashboard() {
  const [activeView, setActiveView] = useState('pyDeepDive');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
      <div className="dashboard-sub-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 20px',
        backgroundColor: '#f9fafb',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 10
      }}>
        <h1 style={{fontSize: '20px', fontWeight: '700', color: '#1f2937', margin: 0}}>
          🚨 ER Dashboard
        </h1>
        <div style={{display: 'flex', gap: '12px'}}>
          <button
            onClick={() => setActiveView('pyDeepDive')}
            style={{
              padding: '8px 20px',
              backgroundColor: activeView === 'pyDeepDive' ? '#4caf50' : '#a5d6a7',
              color: activeView === 'pyDeepDive' ? 'white' : '#2e7d32',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeView === 'pyDeepDive' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
            }}
          >
            PY DEEP DIVE
          </button>
          
          <button
            onClick={() => setActiveView('by3VsPy')}
            style={{
              padding: '8px 20px',
              backgroundColor: activeView === 'by3VsPy' ? '#4caf50' : '#a5d6a7',
              color: activeView === 'by3VsPy' ? 'white' : '#2e7d32',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: activeView === 'by3VsPy' ? '0 2px 8px rgba(76, 175, 80, 0.3)' : 'none'
            }}
          >
            PY GENERAL
          </button>
        </div>
      </div>
      
      <div style={{ flex: 1, overflow: 'auto' }}>
        {activeView === 'pyDeepDive' ? (
          <ERDashboardMain activeView={activeView} setActiveView={setActiveView} />
        ) : (
          <ERByThreeVsPy />
        )}
      </div>
    </div>
  );
}

export default ERDashboard;
